import React, { useState } from "react";
import Modal from "../Modal/Modal";
import classNames from "classnames";
import FutureForm from "./FutureForm/FutureForm";
import OptionsForm from "./OptionForm/Optionform";
import { requestFutOpt, requestRfq, update_form_data } from "../../Redux/features/OrderSection/OrderSectionSlice";
import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { loaderStart, loaderStop, setFUTOPTData, setFUTOPTErrorMsg, setIsWaiting, setTimeoutId } from "../../Redux/features/Dashboard/DashBoardSlice";
import Loading from "../Loading/Loading";
import { useSelector } from "react-redux";
import socket from "../../socket";
type Props = {
  conValue: string;
  setConValue: any;
  contractSet: string;
  setContractSet: any;
  market_id: string;
  iex_symbol?:string
  bidprice: number |string
};

const FutAndOpt = ({ iex_symbol="",market_id, conValue, setConValue, contractSet, setContractSet, bidprice = 0 }: Props) => {
  const [isFutureModalOpen, setFutureModalOpen] = useState(false);
  const [isOptionModalOpen, setIsOptionModalOpen] = useState(false);
  const OptionList = useAppSelector(state => state.orderSection.optionVendor)
  const FutureList = useAppSelector(state => state.orderSection.futureVendor)
  const default_security_set: any = useAppSelector((state) => state.dashBoard.default_security_set);

  const oldTimeout = useAppSelector((state) => state.dashBoard.timeoutId);
  const dispatch = useAppDispatch();
  const handleRequest = (type: "FUT" | "OPT") => {
    dispatch(update_form_data({ algo: undefined }));
    dispatch(requestFutOpt({ security_id: default_security_set.security_id, type: type, socket_id: socket.id }));
 
    dispatch(loaderStart());

    // Clear old timeout if any
    if (oldTimeout) clearTimeout(oldTimeout);

    const timeout = setTimeout(() => {
      dispatch(setFUTOPTErrorMsg("No response received from server in 10 seconds."));
      dispatch(
        setFUTOPTData({
          Key: "",
          Value: {
            cid: "",
            exc: "",
            futlst: [],
            optlst: [],
            rid: "",
            sec: "",
            sectype: "",
            vid: 0,
          },
        })
      );
      dispatch(loaderStop());
      dispatch(setTimeoutId(null));
    }, 20000);

    dispatch(setTimeoutId(timeout));
  };
  const data = useAppSelector((state) => state.dashBoard.futoptData);
  const loader = useAppSelector((state) => state.dashBoard.fut_opt_loader);
  // const loader = false;
  //console.log(default_security_set, "default_security_set");
  return (
    <>
        {FutureList.length !== 0 && (Number(market_id) === 6 || [492517].includes(Number(default_security_set.security_id))) ? (
          <div className="flex cursor-pointer bg-[#f0f1f3] items-center m-auto shadow px-[4px] py-[2px] rounded-md text-[#6e6e6e] gap-2">
          <div
            onClick={() => {
              setFutureModalOpen(true);
              setContractSet("future");
              handleRequest("FUT");
              setConValue(null);
            }}
            className={classNames("px-[4px] text-[10px] m-auto py-[2px] rounded", {
              "bg-white": contractSet === "future",
            })}
          >
            FUT
          </div>
          </div>
        ): null}
        {Number(market_id) === 1 && OptionList.length !== 0 ? (
            <div className="flex cursor-pointer bg-[#f0f1f3] items-center m-auto shadow px-[4px] py-[2px] rounded-md text-[#6e6e6e] gap-2">
          <div
            onClick={() => {
              setIsOptionModalOpen(true);
              setContractSet("option");
              handleRequest("OPT");
              setConValue(null);
              }}
            className={classNames("px-[4px] text-[10px] py-[2px] rounded", {
              "bg-white": contractSet === "option",
            })}
          >
            OPT
          </div>
          </div>
        ):null}
    

      <Modal
        text={`${default_security_set.tabName} Futures`}
        isOpen={isFutureModalOpen}
        onClose={() => {
          setFutureModalOpen(false);
          setContractSet("");
        }}
      >
        {!loader ? (
          <FutureForm  iex_symbol={iex_symbol} contracts={data?.Value?.futlst} setConValue={setConValue} onClose={() => setFutureModalOpen(false)} />
        ) : (
          <div
          style={{
            width: "480px",
            display: "table",
            tableLayout: "fixed",
          }}
          className={
          ` h-48 relative`
          }
        >
          <div className="loading full-page">
            <div>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        )}
      </Modal>
      <Modal
       text={`${default_security_set.tabName} Options`}
        isOpen={isOptionModalOpen}
        onClose={() => {
          setIsOptionModalOpen(false);
          setContractSet("");
        }}
      >
        {!loader ? (
          <OptionsForm iex_symbol={iex_symbol} nearPrice={bidprice} contracts={data?.Value?.optlst} setConValue={setConValue} onClose={() => setIsOptionModalOpen(false)} />
        ) : (
          <>
               <div
          style={{
            width: "480px",
            display: "table",
            tableLayout: "fixed",
          }}
          className={
          ` h-48 relative`
          }
        >
          <div className="loading full-page">
            <div>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default FutAndOpt;
